import { render, staticRenderFns } from "./DetailsHeroPanel.vue?vue&type=template&id=690daddb&scoped=true&"
import script from "./DetailsHeroPanel.vue?vue&type=script&lang=js&"
export * from "./DetailsHeroPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailsHeroPanel.vue?vue&type=style&index=0&id=690daddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690daddb",
  null
  
)

export default component.exports